export { apiFetch as wfbApiFetch, type ErrorWrapper } from '@automata/api';
